import Vue from 'vue';
import VueRouter from 'vue-router';
import ResultList from '../components/ResultList.vue';
import InputFile from '../components/InputFile.vue';
import Contact from '../components/Contact.vue';
import About from '../components/About.vue';

Vue.use(VueRouter);

export default new VueRouter({
  // for production mode begin please uncomment
  base: '/aihlab/rhofold/',
  // production mode end
  // mode: 'history',
  components: {
    ResultList,
    InputFile,
  },
  routes: [
    {
      path: '/',
      component: InputFile,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/predict/:unique_id',
      name: 'predict',
      component: ResultList,
      props: {
        filefield: 'predict',
      },
    },
  ],
});
